import React, { useState } from 'react';
import MapChart from './MapChart';
import MapDialog from './MapDialog';

const AreaSelector = () => {
    const [content, setContent] = useState("");
    const [STName, setSTName] = useState("");
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    return (
        <React.Fragment>
            <MapDialog show={show} StateName={STName} closeModal={handleClose} />
            <div style={{ backgroundColor: 'none'}}>
                <MapChart setTooltipContent={setContent} setStateName={setSTName} setShowDistrict={setShow} />
            </div>
        </React.Fragment>
    );
}

export default AreaSelector;